// extracted by mini-css-extract-plugin
export default {"userWrap":"User__userWrap___TQ2at","avatar":"User__avatar___3M1z1","info":"User__info___2K-DG","id":"User__id___3L1Cp","tags":"User__tags___3wHjP"};